import { doc, getDoc, Timestamp } from 'firebase/firestore'
import { db } from './firebase'
import type { UserData } from '@/types/models'

/**
 * Fetch user data by user ID
 */
export async function getUserDataById(userId: string): Promise<UserData | null> {
  try {
    const userRef = doc(db, 'users', userId)
    const userSnap = await getDoc(userRef)
    
    if (!userSnap.exists()) {
      return null
    }
    
    const data = userSnap.data()
    
    return {
      uid: userSnap.id,
      email: data.email || '',
      displayName: data.displayName || null,
      avatarUrl: data.avatarUrl || null,
      instagram: data.instagram || null,
      firstName: data.firstName || null,
      lastName: data.lastName || null,
      isArtist: data.isArtist || false,
      artistId: data.artistId || null,
      createdAt: data.createdAt instanceof Timestamp ? data.createdAt.toDate() : data.createdAt,
      lastSignIn: data.lastSignIn instanceof Timestamp ? data.lastSignIn.toDate() : data.lastSignIn,
      ...(data.phone && { phone: data.phone }),
    }
  } catch (error) {
    console.error('[getUserDataById] Error fetching user data:', error)
    throw error
  }
}

